import { render, staticRenderFns } from "./LinkedInIcon.vue?vue&type=template&id=e81e86de&lang=pug&"
import script from "./LinkedInIcon.vue?vue&type=script&lang=ts&"
export * from "./LinkedInIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LinkedInIcon.vue"
export default component.exports